import { Components, Theme } from '@mui/material'
import { mixins } from '../mixins'

declare module '@mui/material/Checkbox' {
  interface CheckboxProps {
    'data-is-ai-prefilled'?: boolean
  }
}
export const MuiCheckbox: Components<Omit<Theme, 'components'>>['MuiCheckbox'] = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ 'data-is-ai-prefilled': dataIsAiPrefilled, theme }) => ({
      '& + .MuiFormControlLabel-label': {
        marginTop: 'auto !important',
        marginBottom: 'auto !important',
        '.MuiStack-root': {
          marginBottom: 0,
        },
        fontSize: '14px',
      },
      '&.Mui-disabled': {
        path: {
          fill: 'rgba(0, 0, 0, 0.26)',
        },
      },
      '&.Mui-checked': {
        color: theme.palette.secondary.main,
      },
      padding: mixins.paddingRadioCheckbox,
      ...(dataIsAiPrefilled && {
        '&:not(.Mui-disabled)': {
          path: { fill: theme.palette.secondary.main },
        },
      }),
    }),
  },
}
